import { Component, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreData } from './tools/core-data/core-data';
import { detect } from 'detect-browser';
import { ENavigationRoute } from './models/enums/navigation-route';
import { ENavigationErrorType } from './models/enums/navigation-error-type';
import { Observable } from 'rxjs';

const browser = detect();

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'client';
    PageHeight!: string;
    Overflow!: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private coreData: CoreData) {

    }

    ngAfterContentInit(): void {
        this.PageHeight = `calc(100% - 70px)`;
        this.Overflow = 'auto';

        if (browser && browser.name === 'ie') {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.IE }]);
        }
    }

    @HostListener('window:beforeunload', ['$event'])
    canDeactivate(event: BeforeUnloadEvent): Observable<boolean> | boolean {
        console.log(event);
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        return false;
    }

    updateHeight(event: any) {
        this.Overflow = 'hidden';
        setTimeout(() => {
            this.PageHeight = `calc(100% - ${event})`;
            this.Overflow = 'auto';
        }, 0);
    }
}